import React from "react";

function SampleLogField({ value, onChange }) {

    return (
        <div className="oct_syslog-text-v2">
            <div>
                <h3 className="text-base font-bold text-slate-800 mb-1">Sample Log</h3>
                <p className="text-xs text-slate-500 mb-0">Paste a sample syslog message to test your regex pattern</p>
            </div>
            <textarea className="oct_syslog-textarea-v2"
                rows={4}
                value={value}
                placeholder="Example: Jan 15 10:43:01 server1 systemd[1]: Configuration file /etc/systemd/system.conf changed"
                onChange={(e) => onChange(e.target.value)} />
        </div>
    )
}

export default SampleLogField;
